'use client'

import { useState } from 'react'
import styles from './Customizer.module.css'
import CustomizerModal from '@/components/Modals/CustomizerModal/CustomizerModal'
import { useModalStore } from '@/stores/useModalStore'

export default function Customizer() {
  const { openModal } = useModalStore()

  const handleOpenCustomizer = () => {
    openModal({
      content: <CustomizerModal />,
      closeOnBackdrop: true
    })
  }

  return (
    <>
      <button 
        className={styles.customizerButton}
        onClick={handleOpenCustomizer}
        title="Personalizar"
        aria-label="Personalizar tema"
      >
        <span className={styles.icon}>⚙️</span>
      </button>
    </>
  )
}
